import { z } from 'zod'

import { StayPeriodDateCoerceSchema } from './StayPeriodDateCoerce'

// TODO: Refactor

export const searchRequestStayMatrixElementSchema = z.object({
	leftTopPeriod: StayPeriodDateCoerceSchema,
	rightBottomPeriod: StayPeriodDateCoerceSchema
})

export type SearchRequestStayMatrixElement = z.infer<
	typeof searchRequestStayMatrixElementSchema
>

export const searchRequestStaySchema = z.object({
	defaultStayPeriod: StayPeriodDateCoerceSchema
	// dateMatrix: searchRequestStayMatrixElementSchema.optional()
})
